import React, { useState } from "react";
import National from "@/assets/img/entrega-nacional.png";
import International from "@/assets/img/Entrega-internacional.png";
import Track from "@/assets/img/Rastrear-pedido.png";
import { toast } from "react-toastify";
import CurrencyFormat from "react-currency-format";
import DeliveryItem from "@/app/core/layouts/main-components/delivery/DeliveryItem";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import { GlobalController } from "@/app/core/base/controllers/GlobalController";
import { TotalExpressController } from "@/app/core/base/controllers/TotalExpressController";
import { Countries, MoneyMask } from "@/app/core/util/helpers/MoneyHelper";
import { DateTranslate } from "@/app/core/util/DateTranslater";
import { ShipSmartController } from "@/app/core/base/controllers/ShipSmartController";
import InputMask from "react-input-mask";
import { Typeahead } from "react-bootstrap-typeahead";
import { Dropdown } from "react-bootstrap";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import BoxItem from "@/app/core/layouts/main-components/delivery/BoxItem";
import AddressCard from "@/app/core/layouts/main-components/delivery/AddressCard";
import PackageCard from "@/app/core/layouts/main-components/delivery/PackageCard";
import Storage from "@/app/core/util/Storage";
import ConfirmationModal from "@/app/core/layouts/main-components/delivery/ConfirmationModal";
import { useEffect } from "react";
import { DeliveryController } from "@/app/core/base/controllers/DeliveryController";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import { Panel, Tab, Tabs } from "@bumaga/tabs";
import Quotation from "../../quotation/main";

export default function HomeComponent({ }) {
    const date = new Date();
    const [step, setStep] = useState(1);
    const [nationalModal, setNationalModal] = useState(false);
    const [internationalModal, setInterationalModal] = useState(false);
    const [faster, setFaster] = useState(false);
    const [userData, setUserData] = useState(Storage.getUserData());
    const [result, setResult] = useState({});
    const [box, setBox] = useState({});
    const [origin, setOrigin] = useState({});
    const [destination, setDestination] = useState({});
    const [boxes, setBoxes] = useState([]);
    const [deliveries, setDeliveries] = useState([]);
    const [international, setInternational] = useState([]);

    const [nacional, setNacional] = useState(TotalExpressController.BaseModel);
    const [data, setData] = useState({ origin: {}, userId: userData.id, currency_quote: "USD", currency_payment: "BRL" });
    const enviroment = process.env.REACT_APP_ENV;


    useEffect(() => {
        loadDeliveries()
        // "address_code": 72,
        if (enviroment == "local" || enviroment == "staging") {
            setOrigin({
                "name": "Fabio Rodrigues",
                "street": "R. Farroupilha",
                "neighborhood": "Parque Santo Afonso",
                "city": "Vargem Grande Paulista",
                "state": "SP",
                "state_code": "SP",
                "country": "BR",
                "zipCode": "06730000",
                "postal_code": "06730000",
                "number": "12",
                "complement": "",
                "document": "43060160805",
                "email": "fabiorsilvajr@gmail.com",
                "phone": "5511913152672",
                "phoneExtension": "",
                "personType": 0,
                "address": "R. Farroupilha, Parque Santo Afonso, Vargem Grande Paulista - SP - BR - 06730-000",
                "country_code": "BR"
            });
            setDestination({
                "name": "Fabio Rodrigues",
                "street": "5th Ave",
                "neighborhood": "Manhattan",
                "city": "New York County",
                "state": "NY",
                "state_code": "NY",
                "country": "US",
                "zipCode": "10021",
                "postal_code": "10021",
                "number": "12",
                "complement": "",
                "document": "43060160805",
                "email": "fabiorsilvajr@gmail.com",
                "phone": "5511913152672",
                "phoneExtension": "",
                "personType": 0,
                "address": "5th Ave, Manhattan, New York County - NY - US - ",
                "country_code": "US"
            });
            setBoxes([
                {
                    "name": "Bolsas",
                    "height": 10,
                    "width": 20,
                    "depth": 30,
                    "weight": 1,
                    "price": 250,
                    "itens": [
                        {
                            "name": "contrato",
                            "hscode": "392610",
                            "quantity": 1,
                            "weight": 1,
                            "unit_value": 250,
                            "country_code": "BR"
                        }
                    ]
                }
            ])
        }
    }, [])

    useEffect(() => {
        processResults()
    }, [faster])

    function processResults() {
        let base = result.carriers;
        if (base != undefined) {
            if (faster) {
                const response = base.sort(function (a, b) {
                    return a.transit_days - b.transit_days;
                });

                setResult({ ...result, carriers: response });
            } else {
                for (let s in base) {
                    base[s].price = parseFloat(base[s].currency_payment_amount)
                }
                const response = base.sort(function (a, b) {
                    return a.price - b.price;
                });

                setResult({ ...result, carriers: response });
            }
        }
    }

    function loadDeliveries() {
        DeliveryController.Get(userData.id, 3, res => {
            setDeliveries(res.filter(x => x.origin.country == "BR" && x.destination.country == "BR"));
            setInternational(res.filter(x => x.origin.country != "BR" || x.destination.country != "BR"));
        });
    }

    function handleChange(evt, type) {
        if (evt.target.name == "zipCode" && evt.target.value.length >= 8 && data.type == 1) {
            loadAddress(evt.target.value)
        } else if (evt.target.name == "zipCodeOrigin" && evt.target.value.length >= 8 && data.type == 1) {
            loadAddress(evt.target.value, true)
        } else {
            setData(OnDataChange(data, evt, type));
        }
    }


    function loadAddress(zipCode, origin) {
        GlobalController.GetAddress(zipCode, res => {
            let address = data;
            address.city = res.localidade;
            address.state = res.uf;
            address.line2 = res.complemento;
            address.line1 = `${res.logradouro} ${res.bairro}`;
            if (origin) {
                address.origin = `${address.line1} - ${address.city} - ${address.state}`;
                address.zipCodeOrigin = zipCode;
            } else {
                address.zipCode = zipCode;
                address.address = `${address.line1} - ${address.city} - ${address.state}`;
            }
            setData({ ...data, ...address });
        })
    }

    function handlePackageChange(evt, type) {
        setBox(OnDataChange(box, evt, type));
    }

    function addBox() {
        if (box.height == "" || box.height == undefined ||
            box.width == "" || box.width == undefined ||
            box.depth == "" || box.depth == undefined ||
            box.weight == "" || box.weight == undefined) {
            toast.error(Message.PendingData);
        } else {
            setBoxes([...boxes, box]);
            setBox({});
        }
    }

    function goNacional() {
        setData({ ...data, type: 1 });
        setStep(2);
    }

    function goInternacional() {
        setData({ ...data, type: 2 });
        setStep(2);
    }

    function goSearch() {
        setStep(2);
    }

    function definePackage() {
        let error = false;
        let message = "Está faltando preencher ";

        let baseData = { ...data, origin, destination };

        console.log("Dados checagem", baseData);
        if (baseData.origin.address == undefined || baseData.origin.address == "") {
            error = true;
            message += " Endereço de origem;"
        }
        if (baseData.origin.zipCode == undefined || baseData.origin.zipCode == "") {
            error = true;
            message += " CEP de origem;"
        }
        if (baseData.origin.number == undefined || baseData.origin.number == "") {
            error = true;
            message += " Número de origem;"
        }
        if (baseData.destination.address == undefined || baseData.destination.address == "") {
            error = true;
            message += " Endereço de destino;"
        }
        if (baseData.destination.zipCode == undefined || baseData.destination.zipCode == "") {
            error = true;
            message += " CEP de destino;"
        }
        if (baseData.destination.number == undefined || baseData.destination.number == "") {
            error = true;
            message += " Número de destino;"
        }
        if (baseData.type == 2 && baseData.origin.country_code == baseData.destination.country_code) {
            error = true;
            message += " Em uma cotação internacional o país de entrega não pode ser o mesmo da origem;"
        }

        if (error) {
            toast.error(message);
        } else {
            setData(baseData);
            console.log("Tipo de entrega", baseData);
            if (baseData.type == 2) {
                setStep(5);
            } else {
                setStep(3);
            }
        }
    }

    function getQuotation() {
        let message = "Faltou preencher ";
        let error = false;
        if (data.type == 1) {
            if (data.height == undefined || data.height == "") {
                error = true;
                message += " Altura;"
            }
            if (data.width == undefined || data.width == "") {
                error = true;
                message += " largura;"
            }
            if (data.depth == undefined || data.depth == "") {
                error = true;
                message += " profundidade;"
            }
            if (data.weight == undefined || data.weight == "") {
                error = true;
                message += " peso;"
            }
            if (data.declaredValue == undefined || data.declaredValue == "") {
                error = true;
                message += " valor do conteúdo;";
            }
        } else {
            if (data.insurance == undefined || data.insurance == "") {
                error = true;
                message += " Defina a opção de seguro;";
            }
            if (data.tax == undefined || data.tax == "") {
                error = true;
                message += " Quem deve pagar o imposto;";
            }
            if (data.object == undefined || data.object == "") {
                error = true;
                message += " tipo de produto;";
            }
            if (boxes.length == 0) {
                error = true;
                message += " cadastre uma caixa e os itens dentro dela;";
            }
            if (boxes.length != 0) {
                let contains = boxes.filter(x => x.itens && x.itens.length > 0);

                if (boxes.length != contains.length) {
                    error = true;
                    message += " Tem caixas sem a descrição dos itens dentro dela;";
                }
            }
        }


        if (error) {
            toast.error(message);
        } else {
            if (data.type == 1) {
                //Nacional

                let base = nacional;
                base.declaredValue = data.declaredValue;
                base.depth = data.depth;
                base.height = data.height;
                base.width = data.width;
                base.weight = data.weight;
                base.zipCode = data.destination.zipCode.replace(/\D/g, "");

                TotalExpressController.Quotation(base, res => {
                    console.log("Calculo de frete", res);
                    const today = new Date();
                    const delivery = new Date(today.setDate(today.getDate() + res.deadline));

                    res.deliveryDate = DateTranslate(delivery);
                    if (date.getHours() > 10) {
                        res.collectDate = "Coleta: Amanhã entre as 12 e 18h";
                    } else {
                        res.collectDate = "Coleta: Hoje até as 18h";
                    }
                    setResult(res);
                    setStep(4);
                })

            } else {
                let base = data;
                base.boxes = boxes;
                let items = [];
                for (let s in base.boxes) {
                    if (base.boxes[s].itens != undefined) {
                        items = [...items, ...base.boxes[s].itens]
                        // base.boxes[s].itens = null;
                        delete base.boxes[s].itens;
                    }
                }
                base.address_receiver = base.destination;
                base.address_sender = base.origin;
                delete base.destination;
                delete base.origin;
                if (enviroment == "local" || enviroment == "staging") {
                    // base.address_sender.address_code = 72;
                }
                base.type = "simple";
                // base.items = items;
                ShipSmartController.Quotation(base, res => {
                    console.log("Calculo de frete", res);
                    setResult({ ...res.data, id: res.data.quotation });
                    setStep(4);
                })
            }
        }
    }

    function handleOrigin(evt) {
        console.log("Origem", evt);
        setOrigin(OnDataChange(origin, evt));
    }

    function handleDestination(evt) {
        console.log("Destino", evt);
        setDestination(OnDataChange(destination, evt));
    }

    function handleOriginAddress(address) {
        setOrigin({ ...origin, ...address });
    }
    function handleDestinationAddress(address) {
        setDestination({ ...destination, ...address });
    }

    function addPackage(full) {
        let size = "4";
        if (full) {
            size = "12"
        }
        return (
            <div className="row">
                <div className={`form-group col-md-${size}`}>
                    <span>*Nome da caixa (para sua identificação)</span>
                    <input className="form-control" name="name" value={box && box.name} onChange={evt => handlePackageChange(evt)} />
                </div>
                <div className={`form-group col-md-${size}`}>
                    <span>*Altura da caixa (cm)</span>
                    <input type="number" className="form-control" name="height" value={box && box.height} onChange={evt => handlePackageChange(evt, FieldTypeObj.Number)} />
                </div>
                <div className={`form-group col-md-${size}`}>
                    <span>*Largura da caixa (cm)</span>
                    <input type="number" className="form-control" name="width" value={box && box.width} onChange={evt => handlePackageChange(evt, FieldTypeObj.Number)} />
                </div>
                <div className={`form-group col-md-${size}`}>
                    <span>*Profundidade da caixa (cm)</span>
                    <input type="number" className="form-control" name="depth" value={box && box.depth} onChange={evt => handlePackageChange(evt, FieldTypeObj.Number)} />
                </div>
                <div className={`form-group col-md-${size}`}>
                    <span>*Peso (Kg)</span>
                    <input type="number" className="form-control" name="weight" value={box && box.weight} onChange={evt => handlePackageChange(evt, FieldTypeObj.Number)} />
                </div>
                <div className={`form-group col-md-${size}`}>
                    <span>*Qual é o valor total do conteúdo da caixa?
                        <br />
                        <small>O item será assegurado no valor definido por você logo abaixo.</small>
                    </span>
                    <CurrencyFormat
                        className={`form-control`}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        name="price"
                        value={box.price}
                        prefix={"R$"}
                        onValueChange={(values) => {
                            const { formattedValue, value } = values;
                            handlePackageChange(
                                { target: { value: value, name: "price" } }, FieldTypeObj.Currency
                            );
                        }}
                    />
                </div>
                <div className="col-md-12 text-center mt-0">
                    <button className="btn btn-success" onClick={() => addBox()}>
                        <i className="si si-check mr-2" />
                        Adicionar
                    </button>
                </div>
            </div>
        )
    }

    function removeBox(pos) {
        setBoxes(boxes.filter((x, index) => index != pos));
    }

    function selectInternactional(carrier) {
        let base = data;
        base.serviceValue = carrier.currency_payment_amount;
        setData({ ...base, carrierCode: carrier.code, carrier });
        setInterationalModal(true);
    }

    function openNational() {
        let base = data;

        base.serviceValue = result.serviceValue;
        setData({ ...base });
        setInterationalModal(true);
    }

    function handleItens(itens, index) {
        let old = boxes;
        old[index].itens = itens;
        setBoxes(old);
    }

    function current() {
        switch (step) {
            case 1:
                return (
                    <div className="row">
                        <div className="col-md-12">
                            {/* <h2 className="content-heading font-w700">Sugestões</h2> */}
                            <div className="">
                                <div className="ml-1 mr-1  row border-success">

                                    <a className="block block-bordered border-success block-rounded block-link-shadow text-center col-4 " href="javascript:void(0)" onClick={() => goNacional()}>
                                        <div className="block-content block-content-full mb-0">
                                            <img className="img-avatar  img-avatar-rounded" src={National} alt="" />
                                        </div>
                                        <div className="">
                                            <p className="font-w700 mb-0">
                                                {Translate(Message.NationalDelivery)}
                                            </p>
                                        </div>
                                    </a>

                                    <a className="block block-bordered border-success block-rounded block-link-shadow text-center col-4 " href="javascript:void(0)" onClick={() => goInternacional()}>
                                        <div className="block-content block-content-full mb-0">
                                            <img className="" src={International} alt="" />
                                        </div>
                                        <div className="">
                                            <p className="font-w700 mb-0">
                                                {Translate(Message.InternationalDelivery)}
                                            </p>
                                        </div>
                                    </a>

                                    <a className="block block-bordered border-success block-rounded block-link-shadow text-center col-4 " href="javascript:void(0)">
                                        <div className="block-content block-content-full mt-3 mb-0">
                                            <img className="img-avatar  img-avatar-rounded" src={Track} alt="" />
                                            {/* <i className="si si-pin fa-2x text-success"/> */}
                                        </div>
                                        <div className="">
                                            <p className="font-w700 mb-0">
                                                {Translate(Message.Tracking)}
                                            </p>
                                        </div>
                                    </a>
                                </div>
                            </div>

                            <h2 className="content-heading font-w700 mt-3">{Translate(Message.Actives)}</h2>
                            {/* Colocar as rotas em andamento */}
                            {deliveries && (deliveries.length > 0 || international.length > 0) ?
                                <Tabs>
                                    <div className="row">
                                        <div className="block block-fx-pop block-rounded col-12">
                                            <Tab>
                                                <button className="btn btn-dual">
                                                    <img style={{ height: 32 }} className="mr-2" src={National} alt="" />
                                                    {/* <i className="si si-map mr-2"></i> */}
                                                    ({deliveries.length}) {Translate(Message.NationalDelivery)}
                                                </button>
                                            </Tab>
                                            <Tab>
                                                <button className="btn btn-dual">
                                                    <img style={{ height: 32 }} className="mr-2" src={International} alt="" />
                                                    {/* <i className="si si-globe-alt mr-2"></i> */}
                                                    ({international.length}) {Translate(Message.InternationalDelivery)}
                                                </button>
                                            </Tab>
                                        </div>
                                        <Panel>
                                            {deliveries && deliveries.map(item => (
                                                <div className="col-md-6">
                                                    <DeliveryItem data={item} />
                                                </div>
                                            ))}
                                        </Panel>
                                        <Panel>
                                            {international && international.map(item => (
                                                <div className="col-md-6">
                                                    <DeliveryItem data={item} />
                                                </div>
                                            ))}
                                        </Panel>
                                    </div>
                                </Tabs>
                                : <div className="col-12 text-center">
                                    <h4 className="font-w700 text-dark">{Translate(Message.ZeroDeliveries)}</h4>
                                    <p className="font-w700 text-dark">{Translate(Message.StartDelivery)}</p>
                                    <hr style={{ width: 120 }} />
                                </div>}
                        </div>
                    </div>
                )
            case 2:
                return (
                    <Quotation />

                )
            case 3:
                return <PackageCard
                    data={data}
                    goBack={() => setStep(step - 1)}
                    getQuotation={() => getQuotation()}
                    handleChange={(evt, type) => handleChange(evt, type)} />
            case 4:
                return (
                    <form onSubmit={evt => definePackage()}>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="block block-rounded block-bordered block-fx-pop">
                                    <div className="block-header">
                                        <div className="block-title">
                                            Entrega
                                        </div>
                                    </div>
                                    <div className="block-content">
                                        <div className="block-content row">
                                            {data && data.type == 1 ?
                                                <div className="form-group col-12">
                                                    <div className="block block-rounded block-fx-pop mb-2 js-appear-enabled animated fadeIn" data-toggle="appear">
                                                        <div className="block-content block-content-full border-left border-3x border-success">
                                                            <div className="d-md-flex justify-content-md-between align-items-md-center">
                                                                <div className="p-1 p-md-3">
                                                                    <h3 className="h4 font-w700 mb-1">Total Express</h3>
                                                                    <p className="font-size-sm mb-2">
                                                                        {result && result.collectDate}
                                                                    </p>
                                                                    <p className="font-size-sm text-muted mb-0">
                                                                        Entrega prevista
                                                                        {result && result.deliveryDate}
                                                                    </p>
                                                                </div>
                                                                <div className="p-1 p-md-3">
                                                                    <a className="btn btn-outline-secondary btn-rounded px-3 mr-1 my-1" href="javascript:void(0)">
                                                                        R${MoneyMask(result.serviceValue, 2)}
                                                                    </a>
                                                                    <button className="btn btn-outline-success btn-rounded px-3 my-1" onClick={() => openNational()}>
                                                                        <i className="si si-check mr-1"></i> Confirmar
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                (
                                                    <div className="col-md-12 row">
                                                        <div className="col-md-12">
                                                            <h3 className="text-muted">Selecione uma transportadora</h3>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <div>
                                                                <div class="form-group row gutters-tiny items-push">
                                                                    <div class="col-6">
                                                                        <div class="custom-control custom-block custom-control-primary">
                                                                            <input type="radio" class="custom-control-input" id="db-travel-house-type-private" name="db-travel-house-type" checked={faster == false ? true : false} onClick={() => setFaster(false)} />
                                                                            <label class="custom-control-label" for="db-travel-house-type-private">
                                                                                <span class="d-block text-center">
                                                                                    Mais barato
                                                                                </span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-6">
                                                                        <div class="custom-control custom-block custom-control-primary">
                                                                            <input type="radio" class="custom-control-input" id="db-travel-house-type-shared" name="db-travel-house-type" checked={faster == true ? true : false} onClick={() => setFaster(true)} />
                                                                            <label class="custom-control-label" for="db-travel-house-type-shared">
                                                                                <span class="d-block text-center">
                                                                                    Mais rápido
                                                                                </span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {result && result.carriers && result.carriers.map(item => (
                                                                <div className="block block-rounded block-fx-pop mb-2 js-appear-enabled animated fadeIn" data-toggle="appear">
                                                                    <div className="block-content block-content-full border-left border-3x border-success">
                                                                        <div className="d-md-flex justify-content-md-between align-items-md-center">
                                                                            <div className="p-1 p-md-3">
                                                                                <h3 className="h4 font-w700 mb-1">{item.name}</h3>
                                                                                <p className="font-size-sm text-muted mb-0">
                                                                                    Entrega prevista para {" "}
                                                                                    {item && item.transit_days} dias
                                                                                </p>
                                                                            </div>
                                                                            <div className="p-1 p-md-3">
                                                                                <a className="btn btn-outline-secondary btn-rounded px-3 mr-1 my-1" href="javascript:void(0)">
                                                                                    R${MoneyMask(item.currency_payment_amount, 2)}
                                                                                </a>
                                                                                <button className="btn btn-outline-success btn-rounded px-3 my-1" onClick={() => selectInternactional(item)}>
                                                                                    <i className="si si-check mr-1"></i> Confirmar
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="block block-rounded block-bordered">
                                                                <div className="block-header">
                                                                    <div className="block-title">
                                                                        Caixas
                                                                    </div>
                                                                </div>
                                                                <div className="ml-1 mr-1 mb-1 mt-1">
                                                                    {boxes && boxes.map((item, index) => (
                                                                        <div className="col-12">
                                                                            <BoxItem data={item} presentation={true} />
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 text-center">
                                <button type="button" className="btn btn-hero-lg btn-hero-white text-warning" onClick={() => setStep(data.type == 1 ? 3 : 5)}>
                                    Voltar
                                </button>
                            </div>
                        </div>
                    </form>
                )
            case 5:
                return (
                    <div onSubmit={evt => definePackage()}>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="block block-rounded block-bordered block-fx-pop">
                                    <div className="block-header">
                                        <div className="block-title">
                                            Informações do pacote
                                        </div>
                                        <div className="block-tools">
                                            <Dropdown>
                                                <Dropdown.Toggle>
                                                    Adicionar caixa / envelope
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {addPackage(true)}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                    <div className="block-content">
                                        <div className="row">
                                            <div className="block  block-bordered border-info p-1 pb-3 col-12">
                                                <div className="block-header">
                                                    <div className="block-title">Definições alfandegárias</div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <span>*Seguro?</span>
                                                        <select className="form-control" name="insurance" value={data && data.insurance} onChange={evt => handleChange(evt, FieldTypeObj.Bool)}>
                                                            <option>{Translate(Message.Select)}</option>
                                                            <option value={true}>Sim</option>
                                                            <option value={false}>Não</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <span>*Quem vai pagar o imposto?</span>
                                                        <select className="form-control" name="tax" value={data && data.tax} onChange={evt => handleChange(evt)}>
                                                            <option>{Translate(Message.Select)}</option>
                                                            <option value={"sender"}>Remetente</option>
                                                            <option value={"receiver"}>Destinatário</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <span>*Qual o tipo de produto?</span>
                                                        <select className="form-control" name="object" value={data && data.object} onChange={evt => handleChange(evt)}>
                                                            <option>{Translate(Message.Select)}</option>
                                                            <option value={"doc"}>Documento</option>
                                                            <option value={"not_doc"}>Pacote</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            {boxes && boxes.map((item, index) => (
                                                <div className="col-12">
                                                    <BoxItem data={item} report={itens => handleItens(itens, index)} delivery={data} removeBox={() => removeBox(index)} />
                                                </div>
                                            ))}

                                            {boxes && boxes.length == 0 ?
                                                <div className="block  block-bordered border-info p-1 pb-3 col-12">
                                                    <div className="block-header">
                                                        <div className="block-title">Definições da caixa</div>
                                                    </div>
                                                    {addPackage()}
                                                </div>
                                                : ""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 text-center">
                                <button type="button" className="btn btn-hero-lg btn-hero-white text-warning" onClick={() => setStep(2)}>
                                    Voltar
                                </button>
                                <button type="button" className="btn btn-hero-lg btn-hero-success" onClick={() => getQuotation()}>
                                    Avançar
                                </button>
                            </div>
                        </div>
                    </div>
                )
            case 10:
                return (
                    <div className="text-center">
                        <i className="si si-check fa-2x text-succcess" />
                        <br />
                        <h3 className="text-muted">Pedido efetuado com sucesso</h3>

                        <div className="block block-bordered">
                            <table className="table table-hover">
                                <tbody>
                                    {data && data.files && data.files.map(item => (
                                        <tr>
                                            <td>{item.name}</td>
                                            <td>
                                                <a className="btn btn-dual" href={item.url} target="_blank">
                                                    <i className="si si-cloud-download mr-2" /> Baixar
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <button type="button" className="btn btn-hero-lg btn-hero-success mt-3" onClick={() => setStep(1)}>
                                Voltar ao início
                            </button>
                        </div>
                    </div>
                )
        }
    }

    return (
        <div>
            {step && current()}
            <ConfirmationModal
                show={nationalModal}
                onHide={() => setNationalModal(false)}
                delivery={data}
                boxes={boxes}
                quotation={result}
                // reportDelivery={itens => setData(itens)}
                endPayment={() => setStep(10) | loadDeliveries() | setNationalModal(false)}
            />
            <ConfirmationModal
                show={internationalModal}
                onHide={() => setInterationalModal(false)}
                delivery={data}
                quotation={result}
                boxes={boxes}
                // reportDelivery={itens => setData(itens)}
                endPayment={() => setStep(10) | setInterationalModal(false)}
            />
        </div>

    )
}